import { TabelasAdministrativas } from './tabelasAdministrativas';
/**
 * Tipo de vínculo
 */
export class TipoVinculo extends TabelasAdministrativas {
	constructor(id?: number, nome?: string, ativo?: boolean) {
		super(id, nome, ativo);
	}
}
